import { ConversationTagSource } from "@redotech/redo-common-model/conversation-tags/conversation-tag-source";
import type { PillTheme } from "@redotech/redo-storefront-common/pill-theme";

export const SPAM_TAG = "spam";
export const RECOVER_TAG = "recover";

export interface ConversationTagRecord {
  _id: string;
  teamId: string;
  name: string;
  pillTheme: PillTheme;
  source: ConversationTagSource;
  tagGroupId?: string;
}

export function isTagEditable(tag: { source: ConversationTagSource }): boolean {
  return tag.source !== ConversationTagSource.REDO_SYSTEM;
}

export interface LegacyTagRecord {
  name: string;
  pillTheme?: PillTheme;
}
